/**
 * @author lifei
 * 模块说明：合同中心
 */

// 合同中心
import { contractInfoService } from './info'
import { contractExcelService } from './excel'
import { contractCommodityListService } from './commodityList'
import { contractEarlyWarnService } from './earlyWarn'
import { contractCostExpenseService } from './costExpense'

export const info = new contractInfoService('/api/contract/info')
export const excel = new contractExcelService('/api/contract/excel')
export const commodityList = new contractCommodityListService('/api/contract/commodityList')
export const earlyWarn = new contractEarlyWarnService('/api/contract/earlyWarn')
export const costExpense = new contractCostExpenseService('/api/contract/costExpense')
